export const PREFIX_SUFFIX_MAX_CHAR_COUNT = 32;
// NOTE: We have to clear values using null NOT undefined because lodash/merge
// ignores undefined values. This in turn prevents us from updating the state
// when we want to clear values.
export const CLEAR_VALUE = null;
